import axiosClient from "./axiosClient";

const foodPublicApi = {
  search: ({ query = "", page = 1, limit = 25 } = {}) => {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (query) {
      params.append("search", query);
    }

    return axiosClient.get(`public/foods?${params.toString()}`);
  },
  getDetail: (slug) => axiosClient.get(`public/foods/${slug}`),
};

export default foodPublicApi;
